(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-blocks"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionEl =
      document.querySelector('[data-section-type="collection-blocks"]') ||
      document;
    const sliders = sectionEl.querySelectorAll('.swiper');
    if (!sliders.length) return;

    sliders.forEach((sliderEl) => {
      if (!window.Swiper) {
        console.warn('[collection-blocks] Swiper library not loaded');
        return;
      }

      const wrapperEl = sliderEl.closest('.swiper-slider-wrapper');
      const nextEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-next') : sliderEl.querySelector('.swiper-button-next');
      const prevEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-prev') : sliderEl.querySelector('.swiper-button-prev');

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 1.2,
        spaceBetween: 10,
        touchRatio: 1.3,
        touchAngle: 45,
        longSwipesRatio: 0.3,
        speed: 600,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          thresholdDelta: 30,
          releaseOnEdges: true,
        },
        loop: true,
        ...(sliderEl.dataset.navigation == 'true' ? {
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        } : {}),
        breakpoints: {
          480: {
            slidesPerView: 1.2,
            slidesPerGroup: 1,
          },
          768: {
            slidesPerView: 2.2,
            slidesPerGroup: 1,
          },
          1024: {
            slidesPerView: 2,
            slidesPerGroup: 1,
          }
        },
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionEl =
      document.querySelector('[data-section-type="testimonials"]') ||
      document;
    const sliders = sectionEl.querySelectorAll('.swiper');
    if (!sliders.length) return;

    sliders.forEach((sliderEl) => {
      if (!window.Swiper) {
        console.warn('[testimonials] Swiper library not loaded');
        return;
      }

      const wrapperEl = sliderEl.closest('.swiper-slider-wrapper');
      const nextEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-next') : sliderEl.querySelector('.swiper-button-next');
      const prevEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-prev') : sliderEl.querySelector('.swiper-button-prev');

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        touchRatio: 1.3,
        touchAngle: 45,
        longSwipesRatio: 0.3,
        speed: 600,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          thresholdDelta: 30,
          releaseOnEdges: true,
        },
        loop: true,
        ...(sliderEl.dataset.navigation == 'true' ? {
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        } : {}),
        ...(sliderEl.dataset.autoplay ? {
          autoplay: { 
            delay: parseFloat(sliderEl.dataset.autoplay),
            pauseOnMouseEnter: true
          }
        } : {}),
        breakpoints: {
          480: {
            slidesPerView: 1.2,
            slidesPerGroup: sliderEl.dataset.slidespergroup == 'true' && !sliderEl.dataset.autoplay ? 2 : 1,
          },
          767: {
            slidesPerView: 2,
            slidesPerGroup: sliderEl.dataset.slidespergroup == 'true' && !sliderEl.dataset.autoplay ? 2 : 1,
          },
          1280: {
            slidesPerView: sliderEl.dataset.slidesperview || 4,
            slidesPerGroup: sliderEl.dataset.slidespergroup == 'true' && !sliderEl.dataset.autoplay ? sliderEl.dataset.slidesperview : 1,
          },
        },
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sliders = document.querySelectorAll('[data-section-type="featured-collection"] .swiper');
    
    if (!sliders.length) return;

    sliders.forEach((sliderEl) => {
      if (!window.Swiper) {
        console.warn('[featured-collection] Swiper library not loaded');
        return;
      }

      const wrapperEl = sliderEl.closest('.swiper-slider-wrapper');
      const nextEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-next') : sliderEl.querySelector('.swiper-button-next');
      const prevEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-prev') : sliderEl.querySelector('.swiper-button-prev');

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 2.1,
        spaceBetween: 10,
        touchRatio: 1.3,
        touchAngle: 45,
        longSwipesRatio: 0.3,
        //followFinger: true,
        //touchMoveStopPropagation: false,
        speed: 600,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          thresholdDelta: 30,
          releaseOnEdges: true,
        },
        loop: sliderEl.dataset.autoplay ? true : false,
        ...(sliderEl.dataset.autoplay ? {
          autoplay: { 
            delay: parseFloat(sliderEl.dataset.autoplay),
            pauseOnMouseEnter: true
          }
        } : {}),
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            slidesPerGroup: sliderEl.dataset.slidespergroup == 'true' && !sliderEl.dataset.autoplay ? 2.2 : 1,
          },
          1024: {
            slidesPerView: sliderEl.dataset.slidesperview || 4,
            slidesPerGroup: sliderEl.dataset.slidespergroup == 'true' && !sliderEl.dataset.autoplay ? sliderEl.dataset.slidesperview : 1,
          },
        },
      });
    });
  })();

  document.addEventListener('DOMContentLoaded', () => {
    CompleteTheLookUtils.bindAllVariants();

    //const debounce = (fn, ms) => { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); } };

    function updateFeaturedHeights() {
      const featuredSections = document.querySelectorAll('.featured-collection');

      featuredSections.forEach((section) => {
        const swiper = section.querySelector('.swiper');

        if (swiper) {
          let productPhoto = swiper.querySelector('.swiper-slide-active .complete-the-look__image');
          
          if (productPhoto) {
            let productPhotoHeight = productPhoto.offsetHeight;
            section.style.setProperty('--product-photo-height', productPhotoHeight + 'px');
          }
        }
      });
    }

    updateFeaturedHeights();

    window.addEventListener('resize', theme.utils.debounce(10, updateFeaturedHeights));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-new-list"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sectionEl =
      document.querySelector('[data-section-type="logo-list"]') ||
      document;
    const sliders = sectionEl.querySelectorAll('.swiper');
    if (!sliders.length) return;

    sliders.forEach((sliderEl) => {
      if (!window.Swiper) {
        console.warn('[logo] Swiper library not loaded');
        return;
      }

      const wrapperEl = sliderEl.closest('.swiper-slider-wrapper');
      const nextEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-next') : sliderEl.querySelector('.swiper-button-next');
      const prevEl = wrapperEl ? wrapperEl.querySelector('.swiper-button-prev') : sliderEl.querySelector('.swiper-button-prev');

      const swiper = new Swiper(sliderEl, {
        slidesPerView: 2,
        spaceBetween: 48,
        touchRatio: 1.3,
        touchAngle: 45,
        longSwipesRatio: 0.3,
        speed: 600,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          thresholdDelta: 30,
          releaseOnEdges: true,
        },
        loop: true,
        ...(sliderEl.dataset.navigation == 'true' ? {
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
        } : {}),
        ...(sliderEl.dataset.autoplay ? {
          autoplay: { 
            delay: parseFloat(sliderEl.dataset.autoplay),
            pauseOnMouseEnter: true
          }
        } : {}),
        breakpoints: {
          640: {
            slidesPerView: 3,
            slidesPerGroup: sliderEl.dataset.slidespergroup == 'true' && !sliderEl.dataset.autoplay ? 3 : 1,
          },
          1024: {
            slidesPerView: sliderEl.dataset.slidesperview || 4,
            slidesPerGroup: sliderEl.dataset.slidespergroup == 'true' && !sliderEl.dataset.autoplay ? sliderEl.dataset.slidesperview : 1,
          },
        },
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
